import { render, staticRenderFns } from "./MilkCollection.vue?vue&type=template&id=98e21b3e&scoped=true&"
import script from "./MilkCollection.vue?vue&type=script&lang=js&"
export * from "./MilkCollection.vue?vue&type=script&lang=js&"
import style0 from "./MilkCollection.vue?vue&type=style&index=0&id=98e21b3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98e21b3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCombobox,VDivider,VTextField})
